import React from "react";

import deleteIcon from "#app/assets/icons/trash.svg";

interface DeleteButtonProps {
    handleDelete: () => void; // Функция для управления состоянием загрузки
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ handleDelete }) => {
    return (
        <div
            style={{
                position: "absolute",
                bottom: "14px",
                zIndex: "1",
            }}
        >
            <img
                style={{
                    cursor: "pointer",
                    marginLeft: "10px",
                }}
                title="Удалить"
                alt={``}
                src={deleteIcon}
                onClick={handleDelete}
            />
        </div>
    );
};

export default DeleteButton;
